module.exports = __webpack_public_path__ + "media/wrong.09ba9a6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wrong.mp3
// module id = Yer6
// module chunks = 1